//http请求配置
import axios from 'axios'
import config from '../service/base'
import Utils from '../lib/utils'
const icp = require('../lib/icp')

// 响应拦截
axios.interceptors.response.use(function (response) {
    //console.log(response.data, response.config.responseType, response.request.responseText)
    // IE 8-9
    try {
      if (response.data.data == undefined && response.config.responseType === 'json' && response.request.responseText != null) {
        try {
          // eslint-disable-next-line no-param-reassign
          response.data = JSON.parse(response.request.responseText);
        } catch (e) {
          // ignored
        }
      }
    } catch (e) {
      console.log(e)
    }
    return response;
}, function (error) {
    return Promise.reject(error)
});

export default{
    /*
     *  method: 请求方法。e.g: get/post/delete/put/patch
     *  url: 请求地址
     *  params: 默认为data {}; 当{}对象里包含params时，加入代码中的判断
     *  successCallback: 成功回调函数
     * */
    request: function (method, url, params, successCallBack) {
        var token = Utils.getCookie('token');

        //设置请求参数
        params = params == undefined ? {} : params;

        config.serviceConfig.method = method;
        config.serviceConfig.url = icp.host + icp.port + url + '?token=' + token;

        if (params.params) {
            config.serviceConfig.params = params.params;
            config.serviceConfig.data = {};
        } else {
            config.serviceConfig.data = params;
            config.serviceConfig.params = {};
        }
        //返回请求数据
        axios(config.serviceConfig)
            .then(function (response) {
                //成功回调
                let _data = response.data;
                if (_data.status == 200) {
                    successCallBack(_data.data);
                }else if (_data.status == 998) {
                  Utils.delCookie('token');
                  Utils.delCookie('account');
                  Utils.delCookie('headerimg');
                  window.ROOT_APP.$message({
                    type: 'warning',
                    message: '登录过期，请重新登录'
                  });
                  window.ROOT_APP.$router.push({
                    path: '/home' });
                } else {
                    window.ROOT_APP.$message({
                        type: 'info',
                        message: _data.description
                    });
                }
            })
            .catch(function (response) {
                console.log(response)
              return false;
            });
    }
}



// WEBPACK FOOTER //
// ./src/service/http_request.js